import { FC, useState } from 'react';
import { Button, TableCell, TableRow } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { LaunchpadTable } from '../../../components/mui-overrides/LaunchpadTable';
import { Routes } from '../../../router/Routes';
import { useRevenuePoolAssets } from '../../../hooks/useRevenuePoolAssets';
import { TRevenuePool } from '@brickwise/asset-validation';
import { EmptyTable } from '../../../components/utils/EmtpyTable';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';

const initialPage = 0;
const initialRowsPerPage = 25;

interface Props {
  revenuePool: TRevenuePool;
  reload: boolean;
}

export const RevenuePoolAssetsTable: FC<Props> = ({ revenuePool, reload }) => {
  const { t } = useTranslation();
  const [page, setPage] = useState(initialPage);
  const [rowsPerPage, setRowsPerPage] = useState(initialRowsPerPage);
  const navigate = useNavigate();
  const assets = useRevenuePoolAssets(reload, revenuePool._id);

  return (
    <LaunchpadTable
      hidePagination={false}
      page={page}
      rowsPerPage={rowsPerPage}
      setPage={setPage}
      setRowsPerPage={(rowsPerPage: number) => {
        setPage(initialPage);
        setRowsPerPage(rowsPerPage);
      }}
      useCardStyles={false}
      length={assets.count}
      renderHeader={() => (
        <TableRow>
          <TableCell>{t('revenuePools.detail.assets.props.title')}</TableCell>
          <TableCell></TableCell>
        </TableRow>
      )}
      renderRows={() => {
        if (assets.items.length === 0) {
          return <EmptyTable bottomText={t('general.errors.noItemsFound')} />;
        }
        return (
          <>
            {assets.items.map((row, index) => (
              <TableRow
                onClick={() => navigate(Routes.ASSETS.EDIT.replace(':assetId', row.id))}
                key={index}
                hover
                style={{ cursor: 'pointer', textDecoration: 'none' }}
              >
                <TableCell>{row.descriptions.title}</TableCell>
                <TableCell>
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button variant="contained" size="small" disableElevation color="primary">
                      {t('revenuePools.detail.assets.edit')}
                    </Button>
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </>
        );
      }}
    />
  );
};
